export default __webpack_public_path__ + "assets/models/e6293bba9c244702e1a62173b1d07e5e.glb";